import { useCallback } from 'react';
import { reduxForm, SubmissionError } from 'redux-form';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { addRole, updateRole } from 'services/role-service';
import { Button, themes, Popup2 } from 'libs/ui';
import { required, WhiteStyledField, Title } from 'libs/form';
import { StyledButtonContainer } from './role-form.styled';

const RoleForm = (props) => {
  const { destroy, refresh, setMessage, form, handleSubmit, close, type, initialValues } = props;
  const { t } = useTranslation();
  const isAdd = type === 'addForm';
  const id = initialValues?.id;
  const requiredT = useCallback(required(t), [t]);
  /**
   * after submit
   */
  const afterSubmit = () => {
    refresh();
    setMessage(isAdd ? t('messages.Сохранено успешно') : t('messages.Изменения сохранены'));
    setTimeout(() => {
      setMessage('');
    }, 3000);
    close();
    destroy(form);
  };

  /**
   * submit
   * @param {*} values
   * @returns
   */
  const submit = (values) => {
    // data
    const test = false;

    const out = isAdd ? { ...values } : { role_id: id, name: values.name };

    // test
    if (test) {
      console.log('🚀 ~ submit ~ out:', out);
      return Promise.resolve();
    }

    const method = isAdd ? addRole : updateRole;
    return method(out)
      .then(() => {
        afterSubmit();
      })
      .catch((errors) => {
        if (errors && errors.data) {
          throw new SubmissionError({
            _error: errors.data.type,
          });
        }
        if (errors && errors.message) {
          throw new SubmissionError({
            _error: errors.message,
          });
        }
      });
  };

  const cancel = () => {
    close();
    destroy(form);
  };

  const title = isAdd ? t('form.Новая роль') : initialValues?.name;

  return (
    <Popup2 w={482}>
      <Title>{title}</Title>
      <form onSubmit={handleSubmit(submit)}>
        <WhiteStyledField validate={requiredT} placeholder={t('grid.Название')} type="text" label={t('grid.Название') + config.req} name="name" autoFocus />

        <StyledButtonContainer space="20px">
          <Button type="button" onClick={cancel}>
            {t('buttons.Отменить')}
          </Button>
          <Button theme={themes.blue}>
            <i className="fa fa-save" />
            {t('buttons.Сохранить')}
          </Button>
        </StyledButtonContainer>
      </form>
    </Popup2>
  );
};

export default reduxForm({
  form: 'roleForm',
  // destroyOnUnmount: false,
})(RoleForm);
